<template>
        <div class="container" style="max-height:90vh;">
                <div class="row">
                        <div class="col-md-3 col-lg-3" style="
      max-height: 90vh;
          overflow-y: auto;
          background-color: #fff !important;
        ">
                                <!-- member -->
                                <contacts-list :users="contacts" @currentuser="setCurrent($event)"></contacts-list>
                                <!-- member -->
                        </div>
                        <div class="col-md-9" v-if="this.currentUser.id">
                                <div class="tab-panel">
                                        <div class="mt-4">
                                                <single-chat :user="
                Object.entries(this.currentUser).length <= 0
                  ? ''
                  : this.currentUser
              " v-on:initiatecall="joinCall($event)" v-on:joinedCall="joinCall($event)" :isInChat="false">
                                                </single-chat>
                                        </div>
                                </div>
                        </div>
                </div>

        </div>
</template>

<script>
        import {
                v4 as uuidv4
        } from "uuid";
        import constants from '../config/constants';
        import helper from '../mixins/helper';
        export default {

                data() {
                        return {
                                auth_user: window.auth_user,
                                contacts: [], //this is when call in progress and chat
                                currentUser: {},
                                incomingCallListener: undefined,
                                incomingMessageListener: undefined,
                                token: '',
                        };
                },

                beforeDestroy() {
                        let $ = this;
                        database.ref().child(`calls`).child($.auth_user.id).off('child_added', this
                                .incomingCallListener);
                },
                async created() {
                        let $ = this;
                        var tokenRes = await axios.post('firebase/token');
                        var token = tokenRes.data;
                        if (!token || token == null) {
                                console.log('token is null')
                                swal("Your Session Has Expired. Please Login Again").then(
                                        () => {
                                                window.location.reload();
                                        }
                                );
                                return;
                        }
                        auth.signInWithCustomToken(token).then(() => {
                                $.getContacts();
                                $.setOnlineOffline();
                        }).catch((e) => {
                                console.log(e);
                                swal("Your Session Has Expired. Please Login Again").then(
                                        async () => {
                                                await axios.post('logout');
                                                window.location.reload();
                                        }
                                );
                                return;
                        });
                        window.addEventListener("offline", () => {
                                swal({
                                        title: "Internet Lost..",
                                        timer: 4000
                                }, )
                        });



                },
                mounted() {
                        this.listenForCalls();

                },

                methods: {
                        async joinCall(user) {
                                var channelArray = [`${this.auth_user.id}-${this.auth_user.name}`,
                                        `${user.id}-${user.name}`
                                ];
                                var channelName = channelArray.sort().join('-').replaceAll(' ', '');
                                await this.generateToken(channelName);
                                let params = {
                                        channel: channelName,
                                        friend: user,
                                        authUser: this.auth_user,
                                        token: this.token,
                                        uuid: uuidv4()
                                };
                                helper.eventLog({
                                        'channelId': channelName,
                                        'uuid': params.uuid,
                                        'receiverName': params.friend.name,
                                        'callerName': params.authUser.name,
                                }, constants.eventTypes.join_call);
                                this.$router.push({
                                        name: 'call',
                                        params: params
                                });
                        },

                        setCurrent(user) {
                                this.currentUser = user;
                                this.currentMessage = "";
                        },
                        async generateToken(channelName) {
                                let tokenRequest;
                                let $ = this;
                                try {
                                        tokenRequest = await axios.get(`agora/token?channel=${channelName}`);
                                } catch (e) {
                                        return;
                                }
                                if (tokenRequest.error) {
                                        await this.generateToken(channelName);
                                        return;
                                } else {
                                        $.token = tokenRequest.data.token;
                                }
                        },
                        listenForCalls() {
                                let $ = this;
                                let sessions = database.ref().child(`calls`).child($.auth_user.id);
                                this.incomingCallListener = sessions.on("child_added", async (snap) => {
                                        let call = await snap.val();
                                        if (
                                                call == undefined ||
                                                call == null ||
                                                call.status == "picked_up" ||
                                                call.status == 'declined' ||
                                                call.channelId == undefined
                                        ) {
                                                return;
                                        }
                                        this.$router.push({
                                                name: 'incoming',
                                                params: {
                                                        call: call
                                                }
                                        });
                                });

                        },
                        async setOnlineOffline() {
                                if (auth_user != undefined && auth_user.id != undefined) {
                                        database
                                                .ref()
                                                .child(`users/${auth_user.id}/isOnline`)
                                                .on("value", function (data) {
                                                        if (data.val() == 0) {
                                                                database.ref().child(
                                                                        `users/${auth_user.id}/isOnline`
                                                                ).set(1);
                                                        }
                                                });
                                        await database.ref().child(`users/${auth_user.id}/isOnline`).set(1);

                                        await database
                                                .ref()
                                                .child(`users/${auth_user.id}/isOnline`)
                                                .onDisconnect()
                                                .set(0);
                                }
                        },
                        async getContacts() {
                                var $ = this;
                                await database
                                        .ref()
                                        .child(`friends/${auth_user.id}`)
                                        .orderByChild('lastMessageTimestamp')
                                        .once("value", function (snap) {
                                                if (snap.val() == null || snap.val() == undefined)
                                                        return;
                                                Object.values(snap.val()).forEach(function (contact) {
                                                        contact.id = contact.uid;
                                                        contact.imageUrl =
                                                                'https://staging.jpal.co.jp/storage/profile/default.png'
                                                        contact.isTutor = false;
                                                        contact.isOnline = false;
                                                        $.contacts.push(contact)
                                                        database.ref().child(
                                                                `users/${contact.uid}`
                                                        ).on('value',
                                                                function (
                                                                        snap) {
                                                                        var c = $
                                                                                .contacts
                                                                                .find(function (
                                                                                        c
                                                                                ) {
                                                                                        return c.id ==
                                                                                                contact
                                                                                                .uid
                                                                                })
                                                                        if (c == null ||
                                                                                c ==
                                                                                undefined ||
                                                                                snap
                                                                                .val() ==
                                                                                null ||
                                                                                snap
                                                                                .val() ==
                                                                                undefined
                                                                        )
                                                                                return;
                                                                        c.isOnline =
                                                                                snap
                                                                                .val()
                                                                                .isOnline ===
                                                                                1 ?
                                                                                true :
                                                                                false;
                                                                        c.imageUrl =
                                                                                snap
                                                                                .val()
                                                                                .imageUrl;
                                                                        c.isTutor =
                                                                                snap
                                                                                .val()
                                                                                .isTutor;
                                                                        c.name = snap
                                                                                .val()
                                                                                .name;
                                                                        $
                                                                                .sortContacts();
                                                                })
                                                        database.ref().child(
                                                                `messages/${auth_user.id}/${contact.id}`
                                                        ).off(
                                                                'child_added');
                                                        database.ref().child(
                                                                        `messages/${auth_user.id}/${contact.id}`
                                                                ).limitToLast(1)
                                                                .startAt(Date.now())
                                                                .orderByChild(
                                                                        'timestamp').on(
                                                                        'child_added',
                                                                        function (
                                                                                snap) {
                                                                                if (snap.val()
                                                                                        .senderId !=
                                                                                        auth_user
                                                                                        .id
                                                                                ) {
                                                                                        console.log(snap
                                                                                                .val()
                                                                                        );
                                                                                        $.$toast.success({
                                                                                                title: contact
                                                                                                        .name,
                                                                                                message: snap
                                                                                                        .val()
                                                                                                        .message,
                                                                                        });
                                                                                }

                                                                        })

                                                });
                                        });
                        },
                        async sortContacts() {
                                this.contacts.sort((a, b) => b.isOnline - a.isOnline);
                        }
                },

        };
</script>

<style scoped>
        .vue-notification {
                padding: 10px;
                margin: 0 5px 5px;

                font-size: 12px;

                color: #ffffff;
                background: #44A4FC;
                border-left: 5px solid #187FE7;

        }

        .vue-notification .warn {
                background: #ffb648;
                border-left-color: #f48a06;
        }

        .vue-notification .error {
                background: #E54D42;
                border-left-color: #B82E24;
        }

        .vue-notification .success {
                background: #68CD86;
                border-left-color: #42A85F;
        }
</style>